import useTranslation from 'next-translate/useTranslation';

import { Translate } from '@core/constant';
import { ELanguage } from '@core/type';

import { SelectTextControl } from './SelectTextControl';
import { SelectLanguageProps } from './interface-form-select';

export const SelectLanguageControl = ({
  control,
  ...selectProps
}: SelectLanguageProps): JSX.Element => {
  const { t } = useTranslation(Translate.common.FORM);

  return (
    <SelectTextControl
      name={'language'}
      control={control}
      label={t('language.label')}
      width={'33%'}
      options={Object.values(ELanguage)
        .filter((language) => language !== ELanguage.DEFAULT)
        .map((el) => ({
          value: el.toLowerCase(),
          label: el.toLowerCase(),
        }))}
      {...selectProps}
    />
  );
};
